// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom';
import {useStore} from '@nanostores/react';
import {$user, $is_root} from '@pub/store/user.js';
import {g_path, get_app_paths} from '@pub/utils/path.js';
import {ROUTES, APP_ID, IOS_WEBVIEW, VERSION} from '@pub/utils/constants.js';
import {use_xsrf_rotation, use_zendesk_sso} from '@pub/utils/hooks.js';
import {Splash_screen} from '@pub/comp/splash_screen';
import {Onboarding} from '@pub/features/onboarding';
import {Signin} from '@pub/pages/signin';
import {Signup} from '@pub/pages/signup';
import {Auth_success} from '@pub/pages/auth_success';
import {Link_device} from '@pub/pages/link_device';
import {Maintenance} from '@pub/pages/maintenance';
import {Ip_block} from '@pub/pages/ip_block';
import {Offers} from '@pub/pages/offers';
import {Cashout} from '@pub/pages/cashout.js';
import {Rootland} from '@pub/pages/rootland';
import {Me} from '@pub/pages/me';
import * as api from '@pub/api.js';
import '@pub/css/index.less';

const PAGES_MAP = {
    [ROUTES.ME]: Me,
    [ROUTES.CASHOUT]: Cashout,
    [ROUTES.ROOTLAND]: Rootland,
};

function Data_loader({user}){
    const is_root = useStore($is_root);
    const paths = get_app_paths(is_root);
    const onboarding = APP_ID=='earnapp' && !user.onboarding && !IOS_WEBVIEW;
    return <React.Fragment>
      <Switch>
        {paths.map(p=>{
            if (p.external)
                return null;
            const exact = 'exact' in p ? p.exact : true;
            return <Route key={p.id} path={p.to} exact={exact}
              component={PAGES_MAP[p.id]}/>;
        })}
        <Route path={g_path('/link/:uuid')} exact component={Link_device}/>
        <Redirect to={g_path('/me')}/>
      </Switch>
      {onboarding&&<Onboarding/>}
    </React.Fragment>;
}

function Internal_routes(){
    const user = useStore($user);
    if (!user.email)
        return <Splash_screen/>;
    return <Data_loader user={user}/>;
}

function App(){
    use_zendesk_sso();
    const ready = use_xsrf_rotation(api.rotate_xsrf);
    if (!ready)
      return <Splash_screen/>;
    return <BrowserRouter>
      <Switch>
        <Route path={g_path('/signin')} exact component={Signin}/>
        <Route path={g_path('/signup')} exact component={Signup}/>
        <Route path={g_path('/maintenance')} exact component={Maintenance}/>
        <Route path={g_path('/ip_block')} exact component={Ip_block}/>
        <Route path={g_path('/offers')} exact component={Offers}/>
        <Route path={g_path('/auth/google/callback')} exact
          component={Auth_success}/>
        <Internal_routes/>
        <Redirect to={g_path('/me')}/>
      </Switch>
    </BrowserRouter>;
}

ReactDOM.render(<App/>, document.getElementById('root'));
console.log('earnapp_cp', VERSION);
